import { create } from "zustand";

export const useNotesModal = create((set) => ({
  open: false,
  record: null,
  onSaved: null,
  title: null,
  openModal: (record, onSaved, title) =>
    set({ open: true, record, onSaved, title }),
  close: () => set({ open: false, record: null, onSaved: null, title: null }),
}));
